<template>
  <v-container class="pt-10 pb-16 page-privacy">
    <v-row justify="center">
      <v-col cols="12" md="10">
        <!-- PAGE TITLE -->
        <h1 class="page-title mb-4">TERMS AND CONDITIONS OF SERVICE (INDIA)</h1>

        <!-- 1 -->
        <section>
          <h3>1. THE PLATFORM AS AN AGGREGATOR</h3>
          <p>
            The OhYes platform is a digital marketplace owned and operated by
            Gigvoc Technologies Private Limited.
          </p>
          <ul>
            <li>
              <strong>Role:</strong>
              We act as an intermediary (Aggregator) connecting Users
              ("Customer") with independent service professionals or agencies
              ("Service Partners").
            </li>
            <li>
              <strong>Nature of Relationship:</strong>
              Gigvoc Technologies Pvt Ltd does not provide services directly.
              The contract is a Principal-to-Principal agreement between the
              Customer and the Service Partner.
            </li>
            <li>
              <strong>No Employment:</strong>
              Service Partners are independent entrepreneurs or businesses and
              are not employees of Gigvoc Technologies Pvt Ltd.
            </li>
          </ul>
        </section>

        <!-- 2 -->
        <section>
          <h3>2. QUOTATIONS, INSPECTIONS, AND FINAL PRICING</h3>
          <ul>
            <li>
              <strong>Estimated Rates:</strong>
              Prices shown (e.g., ₹299, ₹499) are indicative estimates and not
              final or binding.
            </li>
            <li>
              <strong>Mandatory On-Site Inspection:</strong>
              The Service Partner must inspect the site or appliance before
              issuing a final quote.
            </li>
            <li>
              <strong>Customer Consent:</strong>
              Work will begin only after the Customer approves the final quote.
            </li>
            <li>
              <strong>Visiting Fee:</strong>
              If the Customer declines after inspection, a nominal
              Visiting/Inspection Fee may apply.
            </li>
          </ul>
        </section>

        <!-- 3 -->
        <section>
          <h3>3. PAYMENT AND TAXATION</h3>
          <ul>
            <li>
              <strong>Payment Terms:</strong>
              Payment is due immediately upon completion of the service.
            </li>
            <li>
              <strong>GST Compliance:</strong>
              All prices are subject to GST. Gigvoc Technologies Pvt Ltd acts as
              a limited agent under Section 9(5) of the CGST Act where
              applicable.
            </li>
            <li>
              <strong>Secure Payments:</strong>
              Users are encouraged to pay via the OhYes app using UPI, Net
              Banking, or Wallets.
            </li>
          </ul>
        </section>

        <!-- 4 -->
        <section>
          <h3>4. CUSTOMER RESPONSIBILITIES</h3>
          <ul>
            <li>
              <strong>Verification:</strong>
              Customers should verify the Service Partner’s ID and credentials
              upon arrival.
            </li>
            <li>
              <strong>Safety:</strong>
              Ensure a safe working environment and access to utilities such as
              water and electricity.
            </li>
            <li>
              <strong>Parts Procurement:</strong>
              Customers may purchase spare parts themselves or authorize the
              Partner to procure them with a valid bill.
            </li>
          </ul>
        </section>

        <!-- 5 -->
        <section>
          <h3>5. LIMITATION OF LIABILITY & WARRANTY</h3>
          <ul>
            <li>
              <strong>Service Quality:</strong>
              The Service Partner is solely responsible for the quality and
              outcome of the work.
            </li>
            <li>
              <strong>No Platform Liability:</strong>
              Gigvoc Technologies Pvt Ltd is not liable for property damage,
              theft, or service deficiencies caused by the Partner.
            </li>
            <li>
              <strong>Warranty:</strong>
              Any service warranty is provided by the Service Partner. The
              platform only facilitates communication.
            </li>
          </ul>
        </section>

        <!-- 6 -->
        <section>
          <h3>6. LOCAL LAWS & HEALTH PROTOCOLS (PANDEMIC)</h3>
          <ul>
            <li>
              <strong>Government Mandates:</strong>
              Both parties must comply with all local municipal and state laws.
            </li>
            <li>
              <strong>Public Health Compliance:</strong>
              MoHFW and state government guidelines must be followed strictly.
            </li>
            <li>
              <strong>Right to Refuse:</strong>
              A Service Partner may refuse service if safety protocols are not
              met or if the area is a containment zone.
            </li>
          </ul>
        </section>

        <!-- 7 -->
        <section>
          <h3>7. DISPUTE RESOLUTION & JURISDICTION</h3>
          <ul>
            <li>
              <strong>Grievance Redressal:</strong>
              Complaints may be addressed to the Grievance Officer at
              <em>[Insert Email]</em>.
            </li>
            <li>
              <strong>Governing Law:</strong>
              These terms are governed by the laws of India.
            </li>
            <li>
              <strong>Jurisdiction:</strong>
              Courts in Ernakulam, Kerala shall have exclusive jurisdiction.
            </li>
          </ul>
        </section>

        <!-- 8 -->
        <section>
          <h3>8. CANCELLATION POLICY</h3>
          <p>
            Cancellations made after a Service Partner has been assigned and is
            en route may attract a cancellation fee to compensate for fuel and
            time.
          </p>
        </section>

        <!-- Advisory -->
        <section>
          <h3>Specific Advice for Gigvoc Technologies (India)</h3>
          <ul>
            <li>Appoint and display a Grievance Officer as required by law.</li>
            <li>
              Generate GST-compliant invoices separating Service and Convenience
              Fees.
            </li>
            <li>
              Consider offering a local language summary (e.g., Malayalam).
            </li>
          </ul>
        </section>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "TermsIndia",
};
</script>

<style scoped>
.page-title {
  font-size: 34px;
  font-weight: 700;
}

section {
  margin-bottom: 28px;
}

h3 {
  font-size: 16px;
  font-weight: 600;
  margin-top: 18px;
  margin-bottom: 6px;
}

p,
li {
  font-size: 15px;
  color: #444;
  line-height: 1.7;
}

ul {
  padding-left: 20px;
}
</style>
